module.exports = __webpack_public_path__ + "img/x-circle.69fdb7b3.svg";